/*

 * @Description:路由守卫
 * @Author: lz
 * @Date: 2021-04-28 12:00:54
 * @LastEditTime: 2021-12-01 16:55:19
 * @LastEditors: gjc
 */
import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // 进度条 css 样式文件

import { message } from 'ant-design-vue'
import { setToken, getToken, getRoutePath } from '@/utils/auth.js'
import { getUserInfo, countDetails } from '@/api/user'
import getPageTitle from '@/utils/get-page-title'

const whiteList = ['/detailShare', '/cannotShare']

const isDev = process.env.NODE_ENV === 'development'
// 进度条设置
router.beforeEach(async (to, from, next) => {
  //设置开发环境token
  isDev && setToken('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsiZmNfcmVzIiwidWNfcmVzIiwiYXV0aF9yZXMiXSwiZXhwIjoxNjQ4MDA0MzUxLCJ1c2VyX25hbWUiOiJ7XCJuaWNrTmFtZVwiOlwi5byg5rWpXCIsXCJ1c2VySWRcIjpcIjEzNzcwNDA2NDY4Nzk2OTQ4NTBcIixcInVzZXJuYW1lXCI6XCIxNTExNTcyNjcxMlwifSIsImp0aSI6IjFmNGU0ZWFlLTU2NGItNGI0Yy1hNmUyLWI0YzUzZTdmMmQ0MCIsImNsaWVudF9pZCI6InBhcnRuZXIiLCJzY29wZSI6WyJBTEwiXX0.EguBxkBdL7WsRLTU1j5HrUSvHTyq7WMqF8jzHKNNT8I')
  const userInfo = store.getters.userInfo
  NProgress.start()
  document.title = getPageTitle(to.meta.title)
  if (getToken()) {
    // 白名单 不去获取用户信息
    if (whiteList.indexOf(to.path) !== -1) {
      NProgress.done()
      next()
    } else if (userInfo) {
      NProgress.done()
      next()
    } else {
      try {
        const userInfo = await getUserInfo()
        const count = await countDetails()
        store.commit('UPDATE_USERINFO', userInfo.data)
        store.commit('UPDATE_COUNT', count.data)
        NProgress.done()
        next()
      } catch (error) {
        message.error({
          content: error,
          duration: 2
        })
        NProgress.done()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      NProgress.done()
      next()
    } else {
      if (!isDev) {
        message.warning({
          content: '即将跳转到伙伴端登录',
          duration: 2
        })
        setTimeout(() => {
          window.open(getRoutePath() + window.location.href, '_self')
        }, 2000)
      }
    }
    NProgress.done()
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

NProgress.configure({
  ease: 'linear',
  speed: 300,
  showSpinner: false
})
